import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getKeycloakGroups } from '@/modules/Authorization/services'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { FilterMultiSelect } from '@/components/ui/filters'

interface KeycloakGroupSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    label?: string
}

const KeycloakGroupSelect = <T extends FieldValues>({
    control,
    name,
    label = 'Nhóm quyền Keycloak mặc định',
}: KeycloakGroupSelectProps<T>) => {
    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEYS.AUTHORIZATION_KEYCLOAK_GROUPS],
        queryFn: getKeycloakGroups,
        staleTime: 60_000,
    })

    const options =
        data?.results?.map((group) => {
            const nameSuffix = group.name ? ` (${group.name})` : ''

            return {
                label: `${group.path}${nameSuffix}`,
                value: group.path,
            }
        }) ?? []

    return (
        <FilterMultiSelect
            control={control}
            name={name}
            label={label}
            placeholder="Chọn các group từ Keycloak"
            searchPlaceholder="Tìm theo tên hoặc path..."
            emptyText="Không tìm thấy Keycloak group."
            options={options}
            disabled={isFetching}
        />
    )
}

export default KeycloakGroupSelect
